import NewYearApi from './NewYearApi';
export default NewYearApi;